import { render } from "./MainScreenVideo.vue?vue&type=template&id=7412f496"
import script from "./MainScreenVideo.vue?vue&type=script&lang=js"
export * from "./MainScreenVideo.vue?vue&type=script&lang=js"

import "./MainScreenVideo.vue?vue&type=style&index=0&id=7412f496&lang=scss"
script.render = render

export default script